import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { FAQS } from "@/data/content";

const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-24 sm:py-36">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
      <SectionHeading
        chapter="09"
        eyebrow="Domande Frequenti"
        title="Le risposte che cercate"
        text="Per ogni altra domanda, siamo sempre disponibili telefonicamente o tramite il modulo contatti."
        testid="faq-heading"
      />
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-sand" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-serif text-lg sm:text-xl font-medium text-ink hover:text-sage hover:no-underline" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-moss" data-testid={`faq-content-${i}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
